// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1PhVI","productName":"Table_productName__318bY"};